import { useSelector } from 'react-redux';
import { getSettings } from '../../store/sales/selectors';

export default function useGetSettingsForPlan() {
    const settings = useSelector((state) => getSettings(state));

    return { ...settings };
}
